import React, { Component } from 'react';
import { parseQuery, compileQuery } from 'utils';

import Menu from 'components/common/Menu/Menu';
import Dropdown from 'components/common/Dropdown/Dropdown';
import District, { getRequest as districtRequest } from './District/District';
import Price, { subtext as priceSubtext, getRequest as priceRequest } from './Price/Price';
import Area, { subtext as areaSubtext, getRequest as areaRequest } from './Area/Area';
import Registration, {
  subtext as registrationSubtext,
  getRequest as registrationRequest,
} from './Registration/Registration';
import Deadline, {
  subtext as deadlineSubtext,
  getRequest as dedlineRequest,
} from './Deadline/Deadline';
import Payment, {
  parseSearch as parseSearchPayment,
  subtext as paymentSubtext,
  getRequest as paymentRequest,
} from './Payment/Payment';
import Type, { parseSearch as parseSearchType, getRequest as typeRequest } from './Type/Type';
import Sea, { parseSearch as parseSearchSea, getRequest as seaRequest } from './Sea/Sea';
import BuildingClass, {
  parseSearch as parseSearchBuilding,
  getRequest as buildingClassRequest,
} from './BuildingClass/BuildingClass';
import Decoration, {
  subtext as decorationSubtext,
  parseSearch as parseDecoration,
  getRequest as decorationRequest,
} from './Decoration/Decoration';
import Advantages, {
  parseSearch as parseAdvantages,
  getRequest as advantagesRequest,
} from './Advantages/Advantages';
import { getRequest as typeFiltersRequest } from 'components/TypeFilters/TypeFilters';

import cn from 'classnames';
import styles from './Filters.scss';

import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { changeFilters } from 'actions/search';
import tracker from '../../../../services/tracker';
import { withTranslation } from 'react-i18next';
import ViewTypes, { getRequest as viewTypesRequest } from './ViewType/ViewType';
import FederalLaw, {
  getRequest as federalLawRequest,
  parseSearch as parseSearchFederalLaw,
} from './FederalLaw/FederalLaw';
import { gaEvent, trackGA } from 'services/ga';
import ReactTooltip from 'react-tooltip';
import { getRegionsForDisplay } from 'utils/regionStorage';

const PAYMENT_HIDEN_WIDTH = 1241;

export const getRequest = (search) => ({
  ...districtRequest(search),
  ...priceRequest(search),
  ...areaRequest(search),
  ...registrationRequest(search),
  ...dedlineRequest(search),
  ...paymentRequest(search),
  ...typeRequest(search),
  ...seaRequest(search),
  ...buildingClassRequest(search),
  ...decorationRequest(search),
  ...typeFiltersRequest(search),
  ...viewTypesRequest(search),
  ...federalLawRequest(search),
  ...advantagesRequest(search),
});

const MAX_MENU_HEIGHT = 'calc(100vh - 210px)';

class Filters extends Component {
  state = {
    handledFilters: {},
  };

  componentDidMount() {
    this.addFilters();
  }

  addFilters = () => {
    const { t } = this.props;
    const search = parseQuery(location.search);
    const payment =
      this.props.currentWidth < PAYMENT_HIDEN_WIDTH
        ? search.payment
          ? parseSearchPayment(search, t).payment
          : []
        : [];

    const filters = {
      building: search.buildingClass ? parseSearchBuilding(search).buildingClass : [],
      sea: search.sea ? [parseSearchSea(search).sea] : [],
      type: search.type ? parseSearchType(search, t).type : [],
      payment,
      interior: search.interior ? parseDecoration(search, t).interior : [],
      advantages: search.advantages ? parseAdvantages(search, t).advantages : [],
      federal_law: search.federal_law ? parseSearchFederalLaw(search).federal_law : [],
    };
    this.setState({ handledFilters: filters });
  };

  getFilters = (filters, request) => {
    const { location, history, changeFilters } = this.props;
    const { pathname, search } = location;
    const query = compileQuery(filters, search, { withoutTypeFilters: false });
    const newSearch = query ? `?${query}` : '';
    const path = `${pathname}${newSearch}`;
    history.push(path);
    changeFilters(request, { withoutTypeFilters: true });
  };

  handleFiltersOpen = () => {
    const { location } = this.props;
    const { pathname, search } = location;
    this.setState({
      path: `${pathname}${search}`,
      request: this.props.search.request,
    });
  };

  handleCancel = () => {
    const { history } = this.props;
    if (this.state.path && this.state.request) {
      history.push(this.state.path);
      this.props.changeFilters(this.state.request);
    }
    this.handleClose();
  };

  handleClose = () => {
    this.dropdown.refs.instance.hideMenu();
  };

  getDropdownRef = (r) => {
    this.dropdown = r;
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location } = nextProps;
    const { pathname, search } = location;
    const path = `${pathname}${search}`;
    this.addFilters();
    if (path !== sessionStorage.getItem('filtersUrl')) {
      sessionStorage.setItem('filtersUrl', path);
    }
  }

  componentDidUpdate(prevProps) {
    // Принудительно обновляем ReactTooltip при изменении состояния
    ReactTooltip.rebuild();
  }

  clearAdditionalFilters = (type) => {
    const filters = this.state.handledFilters;
    filters[type] = [];
    this.setState({ handledFilters: { ...filters } });
  };

  sendFilterEventClick = (event) => {
    const { location } = this.props;
    const mode = location.search.includes('view=map') ? 'map' : 'list';

    tracker.sendEvent(event, { mode });
  };

  handleFilterDropdownClick = ({ eventLabel, mode, objectType }) => {
    const { profile } = this.props;
    trackGA(
      gaEvent.filterButtonsClick({
        eventLabel,
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );
  };

  render() {
    const { location, t, profile, cities } = this.props;
    const search = parseQuery(location.search);
    const { className, currency } = this.props;
    let additionalFiltersCount = 0;
    const isCottegePage = location.pathname.includes('/cottages');
    Object.keys(this.state.handledFilters).map((key) => {
      const filter = this.state.handledFilters[key];
      additionalFiltersCount += Array.isArray(filter) ? filter.length : !!filter;
    });
    const objectType = location.pathname === '/' ? 'zhk' : 'kp_i_th';
    const mode = location.search.includes('view=map') ? 'karta' : 'spisok';

    const eventData = {
      mode: location.search.includes('view=map') ? 'map' : 'list',
    };

    const { user_regions: actualUserRegions } = getRegionsForDisplay(cities || []);
    const selectedRegionsCount = actualUserRegions ? actualUserRegions.length : 0;
    const isMultipleRegionsSelected = selectedRegionsCount > 1;

    return (
      <div className={cn(styles.Filters, className)}>
        <Dropdown
          text={t('components.header.filtersBar.filters.districtTitle')}
          onClick={() => {
            if (!isMultipleRegionsSelected) {
              this.sendFilterEventClick('Web_Filters_District');
              this.handleFilterDropdownClick({ eventLabel: 'raion', mode, objectType });
            }
          }}
          className={cn(styles.Filter, styles.FilterDistrict, {
            [styles.Active]: search.subregion,
            [styles.Disabled]: isMultipleRegionsSelected,
          })}
          textStyle={styles.Title}
          buttonStyle={styles.Button}
          filter={true}
          openByClick={true}
          disabled={isMultipleRegionsSelected}
          data-tip={
            isMultipleRegionsSelected ? 'Доступно только при выборе одного региона' : undefined
          }
          data-for={isMultipleRegionsSelected ? 'global' : undefined}
          data-place={isMultipleRegionsSelected ? 'right' : undefined}
        >
          {!isMultipleRegionsSelected && (
            <District
              className={styles.District}
              dropdownData={this.getFilters}
              search={search}
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
          )}
        </Dropdown>
        <Dropdown
          text={t('components.header.filtersBar.filters.priceTitle')}
          onClick={() => {
            this.sendFilterEventClick('Web_Filters_Price');
            this.handleFilterDropdownClick({ eventLabel: 'cena', mode, objectType });
          }}
          className={cn(styles.Filter, styles.FilterPrice, {
            [styles.Active]: search.priceMin || search.priceMax || search.costMin || search.costMax,
          })}
          textStyle={styles.Title}
          subtext={
            search.priceMin || search.priceMax || search.costMin || search.costMax
              ? priceSubtext(search)
              : null
          }
          buttonStyle={styles.Button}
          filter={true}
          openByClick={true}
        >
          <Menu maxHeight={MAX_MENU_HEIGHT} className="FiltersMenu">
            <Price
              events={{
                left: 'Web_Filters_Price_General',
                right: 'Web_Filters_Price_Kv',
              }}
              eventData={eventData}
              dropdownData={this.getFilters}
              search={search}
              currency={currency}
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
          </Menu>
        </Dropdown>
        <Dropdown
          text={t('components.header.filtersBar.filters.areaTitle')}
          onClick={() => {
            this.sendFilterEventClick('Web_Filters_Square');
            this.handleFilterDropdownClick({ eventLabel: 'ploshchad', mode, objectType });
          }}
          className={cn(styles.Filter, styles.FilterArea, {
            [styles.Active]: search.areaFrom || search.areaTo,
          })}
          textStyle={styles.Title}
          subtext={search.areaFrom || search.areaTo ? areaSubtext(search) : null}
          buttonStyle={styles.Button}
          filter={true}
          openByClick={true}
        >
          <Menu maxHeight={MAX_MENU_HEIGHT} className="FiltersMenu">
            <Area
              dropdownData={this.getFilters}
              search={search}
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
          </Menu>
        </Dropdown>

        {/* not for 960 only */}
        <Dropdown
          leftShift
          text={t('components.header.filtersBar.filters.registrationTitle')}
          onClick={() => {
            this.sendFilterEventClick('Web_Filters_Decoration');
            this.handleFilterDropdownClick({ eventLabel: 'oformlenie', mode, objectType });
          }}
          subtext={registrationSubtext(search, t)}
          className={cn(styles.Filter, styles.FilterRegistration, styles.Hide960, {
            [styles.Active]: search.registration,
          })}
          textStyle={styles.Title}
          buttonStyle={styles.Button}
          filter={true}
          openByClick={true}
        >
          <Menu maxHeight={MAX_MENU_HEIGHT} leftArrow>
            <Registration
              eventData={eventData}
              dropdownData={this.getFilters}
              search={search}
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
          </Menu>
        </Dropdown>
        {/* END not for 960 only */}

        {/* for <960 only */}
        <Dropdown
          rightShift
          text={t('components.header.filtersBar.filters.registrationTitle')}
          onClick={() => {
            this.sendFilterEventClick('Web_Filters_Decoration');
            this.handleFilterDropdownClick({ eventLabel: 'oformlenie', mode, objectType });
          }}
          subtext={search.registration ? registrationSubtext(search, t) : null}
          className={cn(styles.Filter, styles.FilterRegistration, styles.Show960, {
            [styles.Active]: search.registration,
          })}
          textStyle={styles.Title}
          buttonStyle={styles.Button}
          filter={true}
          openByClick={true}
          dropdownMenuStyle="RegistrationDropdownMenu"
        >
          <Menu maxHeight={MAX_MENU_HEIGHT} rightArrow>
            <Registration
              eventData={eventData}
              dropdownData={this.getFilters}
              search={search}
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
          </Menu>
        </Dropdown>
        {/* END for <960 only */}

        <Dropdown
          rightShift
          text={t('components.header.filtersBar.filters.deadlineTitle')}
          onClick={() => {
            this.sendFilterEventClick('Web_Filters_Delivery_Deadline');
            this.handleFilterDropdownClick({ eventLabel: 'varianty_oplaty', mode, objectType });
          }}
          subtext={search.deadline ? deadlineSubtext(search) : null}
          className={cn(styles.Filter, styles.FilterDeadline, { [styles.Active]: search.deadline })}
          textStyle={styles.Title}
          buttonStyle={styles.Button}
          filter={true}
          openByClick={true}
        >
          <Menu maxHeight={MAX_MENU_HEIGHT} rightArrow>
            <Deadline
              eventData={eventData}
              dropdownData={this.getFilters}
              search={search}
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
          </Menu>
        </Dropdown>
        <Dropdown
          rightShift
          text={t('components.header.filtersBar.filters.paymentTitle')}
          onClick={() => {
            this.sendFilterEventClick('Web_Filters_Payment_Options');
            this.handleFilterDropdownClick({ eventLabel: 'varianty_oplaty', mode, objectType });
          }}
          subtext={search.payment ? paymentSubtext(search, t) : null}
          className={cn(styles.Filter, styles.FilterPayment, styles.Hide1240, {
            [styles.Active]: search.payment,
          })}
          textStyle={styles.Title}
          buttonStyle={styles.Button}
          filter={true}
          openByClick={true}
        >
          <Menu maxHeight={MAX_MENU_HEIGHT} rightArrow>
            <Payment
              eventData={eventData}
              onClearClick={this.clearAdditionalFilters}
              dropdownData={this.getFilters}
              search={search}
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
          </Menu>
        </Dropdown>

        {/* <Dropdown */}
        {/* rightShift */}
        {/* text={'Тип недвижимости'} */}
        {/* subtext={typeSubtext(search)} */}
        {/* className={cn(styles.Filter, styles.Type, styles.Hide1500, {[styles.Active]: search.type})} */}
        {/* textStyle={styles.Title} */}
        {/* buttonStyle={styles.Button} */}
        {/* > */}
        {/* <Menu maxHeight={MAX_MENU_HEIGHT} rightArrow> */}
        {/* <Type dropdownData={this.getFilters} search={search} /> */}
        {/* </Menu> */}
        {/* </Dropdown> */}

        {/* <Dropdown */}
        {/* rightShift text={'Расстояние до моря'} */}
        {/* subtext={seaSubtext(search)} */}
        {/* className={cn(styles.Filter, styles.Hide1500, {[styles.Active]: search.sea})} */}
        {/* textStyle={styles.Title} */}
        {/* buttonStyle={styles.Button} */}
        {/* > */}
        {/* <Menu maxHeight={MAX_MENU_HEIGHT} rightArrow> */}
        {/* <Sea dropdownData={this.getFilters} search={search} /> */}
        {/* </Menu> */}
        {/* </Dropdown> */}

        {/* <Dropdown */}
        {/* rightShift text={'Класс дома'} */}
        {/* subtext={seaSubtext(search)} */}
        {/* className={cn(styles.Filter, styles.Hide1500, {[styles.Active]: search.buildingClass})} */}
        {/* textStyle={styles.Title} */}
        {/* buttonStyle={styles.Button} */}
        {/* > */}
        {/* <Menu maxHeight={MAX_MENU_HEIGHT} rightArrow> */}
        {/* <BuildingClass dropdownData={this.getFilters} search={search} /> */}
        {/* </Menu> */}
        {/* </Dropdown> */}

        <Dropdown
          ref={this.getDropdownRef}
          rightShift
          onClick={() => {
            this.handleFilterDropdownClick({ eventLabel: 'eshchyo', mode, objectType });
          }}
          text={t('components.header.filtersBar.filters.moreTitle')}
          additionalCount={additionalFiltersCount}
          className={cn(styles.Filter, styles.FilterAdditional, {
            [styles.Active1240]: search.payment,
            [styles.Active]: search.type || search.sea || search.buildingClass,
          })}
          textStyle={styles.Title}
          dropdownMenuStyle="AddFiltersDropdownMenu"
          buttonStyle={styles.Button}
          onShow={this.handleFiltersOpen}
          filter={true}
          openByClick={true}
        >
          <Menu maxHeight="calc(100vh - 190px)" styleName="AdditionalFilters" rightArrow>
            {/* <Registration dropdownData={this.getFilters} search={search} additional="true" className={cn(styles.Show1200)} /> */}
            {/* <Deadline dropdownData={this.getFilters} search={search} additional="true" /> */}
            <Sea
              eventData={eventData}
              onClearClick={this.clearAdditionalFilters}
              className={styles.AdditionalSea}
              dropdownData={this.getFilters}
              search={search}
              additional="true"
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
            <Payment
              eventData={eventData}
              onClearClick={this.clearAdditionalFilters}
              dropdownData={this.getFilters}
              search={search}
              additional="true"
              className={cn(styles.Show1240)}
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
            <Decoration
              onClearClick={this.clearAdditionalFilters}
              dropdownData={this.getFilters}
              search={search}
              className={styles.AdditionalDecoration}
              additional="true"
              isCottegePage={isCottegePage}
              eventData={eventData}
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
            {!isCottegePage && (
              <Type
                eventData={eventData}
                onClearClick={this.clearAdditionalFilters}
                className={styles.AdditionalType}
                dropdownData={this.getFilters}
                search={search}
                additional="true"
                profile={profile}
                objectType={objectType}
                mode={mode}
              />
            )}
            <BuildingClass
              eventData={eventData}
              onClearClick={this.clearAdditionalFilters}
              dropdownData={this.getFilters}
              search={search}
              additional="true"
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
            <Advantages
              eventData={eventData}
              onClearClick={this.clearAdditionalFilters}
              dropdownData={this.getFilters}
              search={search}
              className={styles.AdditionalAdvantages}
              additional="true"
              isCottegePage={isCottegePage}
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
            <ViewTypes
              eventData={eventData}
              onClearClick={this.clearAdditionalFilters}
              dropdownData={this.getFilters}
              search={search}
              className={styles.AdditionalAdvantages}
              additional="true"
              profile={profile}
              objectType={objectType}
              mode={mode}
            />
          </Menu>
        </Dropdown>
      </div>
    );
  }
}
const mapStateToProps = createSelector(
  (state) => state.search,
  (state) => state.environment.width,
  (state) => state.profile,
  (state) => state.building.cities,
  (search, currentWidth, profile, cities) => ({ search, currentWidth, profile, cities })
);

export default withTranslation()(
  connect(mapStateToProps, { changeFilters }, null, { pure: false })(withRouter(Filters))
);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Filters.js